import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen, HelpCircle, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

const DocumentationPage_es: React.FC = () => {
    const cards = [
        {
            title: 'Preguntas Frecuentes',
            description: 'Encuentra respuestas rápidas a las dudas más comunes sobre el sistema',
            icon: HelpCircle,
            path: '/documentacao/faq',
            color: 'from-blue-500 to-cyan-500'
        },
        {
            title: 'Guía Paso a Paso',
            description: 'Aprende cómo usar el sistema y obtener los mejores resultados',
            icon: BookOpen,
            path: '/documentacao/guia',
            color: 'from-purple-500 to-pink-500'
        }
    ];

    return (
        <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            className="p-6 lg:p-10 max-w-6xl mx-auto flex flex-col gap-8"
        >
            <motion.div
                initial={{ opacity: 0, x: -30 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ delay: 0.1, duration: 0.6 }}
            >
                <h1 className="text-4xl font-black leading-tight tracking-[-0.033em] text-transparent bg-clip-text bg-gradient-primary mb-2">
                    Documentación
                </h1>
                <p className="text-lg text-gray-600 dark:text-gray-400">
                    Todo lo que necesitas saber para dominar el sistema
                </p>
            </motion.div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {cards.map((card, index) => {
                    const Icon = card.icon;
                    return (
                        <motion.div
                            key={card.title}
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ delay: 0.2 + index * 0.1, duration: 0.5 }}
                        >
                            <Link to={card.path}>
                                <motion.div
                                    className="card p-8 h-full flex flex-col gap-4 cursor-pointer group"
                                    whileHover={{ scale: 1.02, y: -4 }}
                                    whileTap={{ scale: 0.98 }}
                                >
                                    <div className={`w-16 h-16 rounded-2xl bg-gradient-to-br ${card.color} flex items-center justify-center shadow-lg`}>
                                        <Icon className="size-8 text-white" />
                                    </div>

                                    <div className="flex-grow">
                                        <h2 className="text-2xl font-bold text-[#181411] dark:text-white mb-2">
                                            {card.title}
                                        </h2>
                                        <p className="text-gray-600 dark:text-gray-400">
                                            {card.description}
                                        </p>
                                    </div>

                                    <div className="flex items-center gap-2 text-primary font-semibold group-hover:gap-3 transition-all">
                                        Acceder
                                        <ArrowRight className="size-5" />
                                    </div>
                                </motion.div>
                            </Link>
                        </motion.div>
                    );
                })}
            </div>

            <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 0.5, duration: 0.5 }}
                className="card p-6 bg-gradient-to-br from-primary/5 to-primary/10 dark:from-primary/10 dark:to-primary/20 border-primary/20"
            >
                <div className="flex items-start gap-4">
                    <div className="size-12 rounded-full bg-primary/20 flex items-center justify-center shrink-0">
                        <span className="text-2xl">💡</span>
                    </div>
                    <div>
                        <h3 className="text-lg font-bold text-[#181411] dark:text-white mb-2">
                            ¿Necesitas Ayuda Adicional?
                        </h3>
                        <p className="text-gray-600 dark:text-gray-400">
                            Si no encuentras lo que buscas en la documentación, contacta con nuestro soporte a través de la página de Ayuda.
                        </p>
                    </div>
                </div>
            </motion.div>

            {/* Legal Policies Link - Small and discrete */}
            <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 0.6, duration: 0.5 }}
                className="text-center pt-4 border-t border-gray-200 dark:border-gray-700"
            >
                <a
                    href="/legal"
                    target="_blank"
                    className="text-sm text-gray-500 dark:text-gray-500 hover:text-primary dark:hover:text-primary transition-colors"
                >
                    Términos de Uso • Política de Privacidad • Aviso Legal
                </a>
            </motion.div>
        </motion.div>
    );
};

export default DocumentationPage_es;
